// extracted by mini-css-extract-plugin
module.exports = {"iconWrapper":"_2p7YSM_sbOEk4KQ8RGosCm"};